import { render, staticRenderFns } from "./AbsenceListTable.vue?vue&type=template&id=706b77c5&scoped=true&"
import script from "./AbsenceListTable.vue?vue&type=script&lang=js&"
export * from "./AbsenceListTable.vue?vue&type=script&lang=js&"
import style0 from "./AbsenceListTable.vue?vue&type=style&index=0&id=706b77c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b77c5",
  null
  
)

export default component.exports